import { Divider } from "./Divider";

export default Divider;
